import { NativeCommand, NativeCommandEnum } from '../models/commands';

/** TTL for the in-flight guard, sized to cover MAUI present latency. */
export const IN_FLIGHT_TTL_MS = 750;

/** Commands that open a native screen / external app and must not double-launch. */
export const GUARDED_COMMANDS: ReadonlySet<NativeCommandEnum> = new Set([
  NativeCommandEnum.AddAssetNative,
  NativeCommandEnum.NavigateToMaui,
  NativeCommandEnum.NavigateTo,
  NativeCommandEnum.OpenBluetoothSettings,
  NativeCommandEnum.OpenAutoMowerDirect,
  NativeCommandEnum.InitiateEposInstallation,
  NativeCommandEnum.NavigateToLogin,
]);

/** Stringify with recursively sorted keys so spread-built params produce the same key. */
export const stableStringify = (value: unknown): string => {
  if (value === null || typeof value !== 'object') {
    return JSON.stringify(value) ?? 'undefined';
  }
  if (Array.isArray(value)) {
    return `[${value.map(stableStringify).join(',')}]`;
  }
  const obj = value as Record<string, unknown>;
  const keys = Object.keys(obj).sort((a, b) => a.localeCompare(b));
  const entries = keys.map((k) => JSON.stringify(k) + ':' + stableStringify(obj[k]));
  return `{${entries.join(',')}}`;
};

export const getNativeCommandKey = (command: NativeCommand<NativeCommandEnum>): string =>
  `${command.name}:${stableStringify(command.params)}`;
